// extracted by mini-css-extract-plugin
module.exports = {"Topic":"Topic-3AcMs0me"};